import React, { PropTypes } from 'react'
import { set, omit } from 'lodash'
import RaisedButton from 'material-ui/RaisedButton'
import Contact from './contact'

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    maxWidth: '200px',
    marginTop: '1em',
    position: 'relative'
  }
}

const Contacts = (props) => {
  let { value: contacts } = props
  if (!contacts) {
    contacts = {}
  }

  const handleContactChange = (contactsKey, contactKey) => (event, key, value) => {
    set(contacts, `${contactsKey}.${contactKey}`, event.target.value)
    props.onChange(event, contacts)
  }

  const handleContactDelete = contactKey => (event, key, value) => {
    contacts = omit(contacts, contactKey)
    props.onChange(event, contacts)
  }

  const addContact = (event) => {
    const contactKey = `contact-${Math.floor(Math.random() * 1000000)}`
    set(contacts, contactKey, {})
    props.onChange(event, contacts)
  }

  return (
    <div style={styles.wrapper}>
      {contacts && (Object.keys(contacts) || []).map((contactKey, i) => {
        const contact = contacts[contactKey] || {}
        return (
          <div key={`contact-${contactKey}-${i}`}>
            <Contact
              contact={contact}
              contactKey={contactKey}
              {...props}
              handleContactChange={handleContactChange}
              handleContactDelete={handleContactDelete}
            />
          </div>
        )
      })}
      <RaisedButton
        label='Add New Contact'
        primary
        onClick={e => {
          addContact(e)
        }}
      />
    </div>
  )
}

// @ts-ignore
Contacts.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default Contacts
